import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_17_2062)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.41 8.58997L12 13.17L16.59 8.58997L18 9.99997L12 16L6 9.99997L7.41 8.58997Z" })));
export default SvgChevron;
